<template>
  <div>
    <div v-if="focusedName" class="item-title">{{$to(focusedName)}}</div>
    <div v-if="focusedDescription" class="item-description">{{$to(focusedDescription)}}</div>
    <div class="image-preview" :style="{backgroundImage: `url(${focusedUrl})` }"></div>
    <div style="display: flex;">
      <div>
        <button class="btn btn-primary" @click="focusPrevious" :disabled="this.disabledPrevious">{{ $t('previous') }}</button>
      </div>
      <div style="flex-grow: 1; text-align: center">{{focusedNumber}} / {{carouselSize}}</div>
      <div>
        <button class="btn btn-primary" @click="focusNext" :disabled="this.disabledNext">{{ $t('next') }}</button>
      </div>
    </div>
    <div style="margin-top: 5px; display: flex">
      <input type="number" v-model="jumpTo" style="flex-grow: 1">
      <button class="btn btn-primary" @click="focusJumpTo">Jump to</button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapActions } from 'vuex';

  export default {
    name: "ImageCarousel",
    props: {
      disabledNext: false,
      disabledPrevious: false,
      focusedIndex: {
        type: Number
      },
      items: {
        type: Array
      }
    },
    data() {
      return {
        jumpTo: null,
        index: this.focusedIndex
      }
    },
    methods: {
      focusPrevious() {
        this.index = Math.max(0, this.index === 0 ? this.items.length - 1 : this.index - 1);
      },
      focusNext() {
        this.index = Math.min(this.items.length - 1, this.items.length === 0 ? 0 : (this.index + 1) % this.items.length);
      },
      focusJumpTo() {
        if (0 < this.jumpTo && this.jumpTo <= this.items.length) {
          this.index = this.jumpTo - 1;
          this.jumpTo = null
        }
      }
    },
    computed: {
      focusedItem() {
        return this.index !== null ? this.items[this.index] : null;
      },
      focusedName() {
        return this.focusedItem ? this.focusedItem.name : null;
      },
      focusedDescription() {
        return this.focusedItem ? this.focusedItem.description : null;
      },
      focusedUrl() {
        return this.focusedItem ? `${Parameters.urlFileServer}${this.focusedItem.url}` : '/img/photo-placeholder.jpg';
      },
      carouselSize() {
        return this.items.length
      },
      focusedNumber() {
        return this.index === null ? 0 : this.index + 1
      }
    },
    watch: {
      index: function(newValue, oldValue) {
        this.$emit("indexChanged", newValue, oldValue);
      }
    }
  }
</script>
<style lang="scss" scoped>
  .image-preview {
    display: flex;
    height: 260px;
    border-radius: 5px;
    border: 1px solid #d9d9d9;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .item-title {
    font-weight: bold;
  }
  .item-description {
    color: gray;
  }
  button:disabled {
    background: #dddddd;
  }
</style>